import { render, staticRenderFns } from "./EmptyBar.vue?vue&type=template&id=4f8e98e6&scoped=true"
import script from "./EmptyBar.vue?vue&type=script&lang=js"
export * from "./EmptyBar.vue?vue&type=script&lang=js"
import style0 from "./EmptyBar.vue?vue&type=style&index=0&id=4f8e98e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8e98e6",
  null
  
)

export default component.exports